import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { AdvertiserSubSectorListListDatatableComponent } from './components/advertiser-sub-sector-list-datatable/advertiser-sub-sector-list-datatable.component';

const DECLARATIONS = [AdvertiserSubSectorListListDatatableComponent];

const MODULES = [SharedModule];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class AdvertiserSubSectorModule {}
